<div class="product-card grow fill flex flex--column relative">
  @if (useNewProductCardLayout) {
    <div class="rounded-large white-bg overflow-hidden border">
      <div
        class="content-container flex"
        [class.nordic-blue-400-bg]="isSpecialUpsellProduct"
        [class.reversed]="upsellLayout"
        data-testid="product-card-content-container"
      >
        <div
          class="relative flex flex--shrink0 overflow-hidden"
          [ngClass]="upsellLayout ? 'flex--basis-half' : 'image-container'"
        >
          @if (categoryIcons?.length > 0) {
            <div
              class="absolute flex flex--center image-container__icons grey-100-text"
              data-testid="product-card-category-icons"
            >
              <fcom-icon class="ms-xxsmall-r image-icon" [name]="categoryIcons[0]" />
              @if (categoryIcons.length === 2) {
                <fcom-icon class="ms-xxsmall-r image-icon" [name]="SvgLibraryIcon.PLUS" />
                <fcom-icon class="ms-xxsmall-r image-icon" [name]="categoryIcons[1]" />
              }
            </div>
          }
          @if (image) {
            <fcom-image
              class="picture block flex--self-stretch"
              [imageData]="image"
              [ratio]="isLaptopUp ? '16x9' : '21x9'"
              [scale]="false"
              [fillParent]="isLaptopUp"
            />
          }
          @if (productTags.length && showStackableLabels) {
            <div
              class="flex absolute flex--column ps-xsmall-y pr-xxsmall-x gap-xxsmall fill tags-column"
              data-testid="product-card-tags-column"
            >
              @for (productTag of productTags; track productTag.localizationKey) {
                <fcom-tag data-testid="product-card-product-tag" [theme]="productTag.theme">
                  @if (productTag.icon) {
                    <fcom-icon class="icon-small" [name]="productTag.icon" />
                  }
                  <span class="overflow-hidden truncate" [class.ms-xxsmall-l]="productTag.icon">{{
                    productTag.localizationKey | finLocalization
                  }}</span>
                </fcom-tag>
              }
            </div>
          }
        </div>
        <div class="flex-1 flex flex--column pr-small-x ps-medium-y">
          <div class="flex flex--space-between">
            <h2 class="font-heading-4" [class.white-text]="isSpecialUpsellProduct" data-testid="product-card-title">
              {{ title }}
            </h2>
            @if (!countText && productTags.length && !showStackableLabels) {
              <div class="ps-small-l">
                <fcom-tag data-testid="product-card-product-tag" [theme]="productTags[0].theme">
                  @if (productTags[0]?.icon) {
                    <fcom-icon class="icon-small" [name]="productTags[0].icon" />
                  }
                  <span [class.ms-xxsmall-l]="productTags[0]?.icon">{{
                    productTags[0].localizationKey | finLocalization
                  }}</span>
                </fcom-tag>
              </div>
            }
          </div>
          @if (showDetailText && detailText) {
            <p data-testid="product-card-detail-text">{{ detailText }}</p>
          }

          <div
            class="flex-1 flex flex--row flex--space-between"
            [ngClass]="!upsellLayout ? 'flex--flex--space-between' : 'flex--column'"
          >
            <div
              class="flex-1 flex"
              [class.flex--column]="!upsellLayout"
              [class.flex--self-end]="!upsellLayout"
              [class.flex--wrap]="upsellLayout"
              [class.ps-xsmall-t]="upsellLayout"
            >
              @if (!countText) {
                @if (lowestPrice) {
                  <div class="flex flex--middle">
                    <span
                      class="font-body-2"
                      [class.white-text]="isSpecialUpsellProduct"
                      data-testid="product-card-starting-from-label"
                      >{{ 'pricesStartingFrom' | finLocalization }}</span
                    >

                    @if (originalPrice) {
                      <span
                        class="font-body-2 strike-through ps-xxsmall-l"
                        [class.white-text]="isSpecialUpsellProduct"
                        data-testid="product-card-original-price"
                        >{{ originalPrice }}</span
                      >
                    }
                  </div>
                  <div class="flex flex--middle">
                    <span
                      class="font-heading-5"
                      [class.heather-700-text]="originalPrice && !isSpecialUpsellProduct"
                      [class.white-text]="isSpecialUpsellProduct"
                      [class.ms-xsmall-l]="upsellLayout"
                      [class.ms-medium-r]="upsellLayout"
                      data-testid="product-card-price"
                      >{{ lowestPrice }}</span
                    >
                    @if (aviosLowestPrice) {
                      <span
                        class="font-body-1 medium-type ps-xxsmall-l flex flex--middle"
                        data-testid="product-card-avios-price"
                      >
                        /
                        <fcom-icon class="icon-small ms-xxsmall-x" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
                        {{ aviosLowestPrice }}
                        {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
                      </span>
                    }
                  </div>
                }
              }
            </div>
            <div [ngClass]="{ 'fill ps-xlarge-y': hideButton && isLaptopUp }" data-testid="cta-button-container">
              @if (!hideButton) {
                <fcom-button
                  class="block ps-xlarge-t flex--self-end"
                  [mode]="upsellLayout ? ButtonMode.FILL : ButtonMode.INLINE"
                  [loading]="loading"
                  [theme]="buttonTheme"
                  [text]="buttonText"
                  [icon]="{ name: buttonIcon, position: buttonIconPosition }"
                  [title]="buttonAriaText"
                  [aria]="{
                    label: buttonAriaText,
                    role: 'button',
                    loadingLabel: 'actions.loading' | finLocalization,
                  }"
                  [focusOnRender]="focusOnBtn()"
                  (clickBtn)="emitProductCategory($event)"
                />
              }
            </div>
          </div>
        </div>
      </div>

      @if (countText) {
        <div class="border-top font-body-1 bold-type ps-xsmall-y pr-small-x flex" data-testid="product-card-count-text">
          <span>{{ countText }}: {{ price }}</span>
          @if (aviosPrice$ | async) {
            <span class="font-body-1 medium-type ps-xxsmall-l flex flex--middle" data-testid="product-card-avios-price">
              /
              <fcom-icon class="icon-small ms-xxsmall-x" [name]="SvgLibraryIcon.AVIOS_CURRENCY" />
              {{ aviosPrice$ | async | finMap: 'amount' | finPoints }}
              {{ 'ancillaries.benefits.labels.plusPoints' | finLocalization }}
            </span>
          }
        </div>
      }

      <fcom-notification
        class="border-top"
        *ngIf="notificationText"
        [theme]="notificationTheme"
        [layout]="NotificationLayout.EDGE_TO_EDGE"
        [title]="notificationTitle"
        [iconName]="notificationIcon"
        [removeHorizontalPadding]="true"
      >
        <p [innerHTML]="notificationText | finSafe: 'html'"></p>
      </fcom-notification>
    </div>
  } @else {
    <fcom-image
      *ngIf="image"
      class="picture block rounded-top-large border-top border-left border-right border"
      [ratio]="'21x9'"
      [imageData]="image"
    />

    <div
      class="flex-1 pr-small-x ps-medium-y white-bg flex flex--column rounded-bottom-large border-bottom border-left border-right border"
    >
      <h2 class="nordic-blue-900-text font-heading-4">{{ title }}</h2>

      @if (lowestPrice) {
        <div class="flex flex--middle">
          <span class="font-body-2 ps-xxsmall-r" data-testid="product-card-starting-from-label">{{
            'pricesStartingFrom' | finLocalization
          }}</span>
          <span
            [ngClass]="{
              'font-heading-5': !originalPrice,
              'strike-through': originalPrice,
              'font-body-2': originalPrice,
            }"
            data-testid="product-card-starting-from-price"
            >{{ originalPrice ? originalPrice : lowestPrice }}</span
          >
          @if (originalPrice) {
            <span class="font-heading-5 heather-700-text ps-xxsmall-l" data-testid="product-card-discounted-price">{{
              lowestPrice
            }}</span>
          }
        </div>
      }

      @if (productTags.length) {
        <fcom-tag data-testid="product-card-product-tag" [theme]="productTags[0].theme">
          @if (productTags[0]?.icon) {
            <fcom-icon class="icon-small" [name]="productTags[0].icon" />
          }
          <span [class.ms-xxsmall-l]="productTags[0]?.icon">{{
            productTags[0].localizationKey | finLocalization
          }}</span>
        </fcom-tag>
      }

      <p *ngIf="detailText" class="ps-xsmall-t ps-small-b font-body-1 flex-1">{{ detailText }}</p>

      <ng-container *ngIf="statusText || purchasedText">
        <hr class="border-top-dashed nordic-blue-50-border" aria-hidden="true" />

        <div class="ps-small-y align-right">
          <div class="nordic-blue-900-text font-body-1" *ngIf="purchasedText">
            {{ purchasedText }}
          </div>
          <div
            class="font-body-1"
            [ngClass]="{
              'medium-type': hasAddedItems,
              'nordic-nordic-blue-900-100-text': hasAddedItems,
              'nordic-blue-900-text': !hasAddedItems,
            }"
          >
            {{ statusText }}
          </div>
          <div *ngIf="price" class="font-body-1 nordic-blue-900-text">{{ price }}</div>
        </div>

        <hr class="border-top-dashed nordic-blue-50-border" aria-hidden="true" />
      </ng-container>

      <div class="align-center">
        <fcom-button
          *ngIf="!hideButton"
          class="block ps-small-t"
          [mode]="ButtonMode.FILL"
          [loading]="loading"
          [theme]="buttonTheme"
          [text]="buttonText"
          [icon]="{ name: buttonIcon, position: IconPosition.RIGHT }"
          [title]="buttonAriaText"
          [aria]="{ label: buttonAriaText, role: 'button', loadingLabel: 'actions.loading' | finLocalization }"
          [focusOnRender]="focusOnBtn()"
          (clickBtn)="emitProductCategory($event)"
        />

        <fcom-notification
          *ngIf="notificationText"
          class="block ps-small-y ps-small-t align-left"
          [theme]="notificationTheme"
          [title]="notificationTitle"
          [iconName]="notificationIcon"
        >
          {{ notificationText }}
        </fcom-notification>
      </div>
    </div>
  }
</div>
